import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Storage from "../../utils/storage";
import { uploadDoc, uploadReset } from "../../redux/Actions/SingleUserActions";
import UserNav from "../../components/UserNav/UserNav";
import Sidebar from "../../components/Sidebar/Sidebar";
import UploadWidget from "../../utils/widget";
import Loader from "../../components/Loader/Loader";
import Dummy from "../../assets/assets/account.svg";
import {
  getUserStatus,
  getRequiredDocs,

} from "../../redux/Actions/GetDocsActions";
import InputField from "../../utils/InputField";
import { useHistory } from "react-router-dom";
import Alert from "../../utils/Alert";
import Requirement from "./Requirement";
import { PropTypes } from "prop-types";
import Spinner from "react-spinner-material";

const DocumentUpload = ({
  isUploading,
  uploadSuccess,
  uploadDoc,
  getStatus,
  uploadReset,
  requiredDocs,
  getRequiredDocs,
  isFetchingRequiredDocs,
}) => {

  const history = useHistory();

  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let img = user && user.logo;
  let compImg = user && user.company && user.company.logo;
  let username = user && user.first_name;
  let name = user && user.name;
  let categoryChoice = user && user.category_id;


  const [state, setState] = useState({
    openModal: false,
    fileResult: {},
    allResult: [],
    errorMessage: "",
    items: [],
    document: [],
    inputValue: "",
  });

  useEffect(
    () => {
      uploadReset();
      const type = "default";
      getRequiredDocs(type);
      getStatus();

  
    },
    // eslint-disable-next-line
    [getRequiredDocs, getStatus]
  );

  const categoryDocs =
    requiredDocs &&
    requiredDocs[categoryChoice] &&
    requiredDocs[categoryChoice].documents;



  function handleDataFetch(fileResult) {
    let allResult = [...state.allResult];
    let index = allResult.findIndex((el) => el.id === fileResult.id);
    if (index >= 0) {
      allResult[index].url = fileResult.url;
    } else {
      allResult.push(fileResult);
    }
    setState({ allResult });
  }

  const handleRemoval = (fileResult) => {
    state.allResult &&
      state.allResult.splice(
        state.allResult.findIndex((item) => item.id === fileResult.id),
        1
      );
    setState(JSON.parse(JSON.stringify(state)));
    return state.allResult;
  };

  const submitDocs = () => {
    const files = { document: state.allResult };
    uploadDoc(files);
  };

  useEffect(
    () => {
      if (uploadSuccess) {
        state.errorMessage = "";
        Alert(
          true,
          "success",
          "Success message",
          "Your application has been submitted for review."
        );
        history.push("/dashboard");
        setState({
          ...state,
          errorMessage: "",
        });
      }
    },
    // eslint-disable-next-line
    [uploadSuccess]
  );

  return (
    <div className="container">
      <UserNav />
      <Sidebar />

      <main className="container-body">
        <div>
          <div className="user-info">
            <div className="user-info-image">
              <img src={img || compImg || Dummy} alt="pic" />
            </div>
            <div className="user-info-names">
              <p>Welcome,</p>
              <h2>{name || username}</h2>
              <h3>
                Your account is currently being setup - this means there’re a
                couple more things to finish up before you can proceed.
              </h3>
            </div>
          </div>
        </div>

        <div className="upload-flex">
          <div className="upload-title">
            <h2>Activation Documents</h2>
            <p>The documents we ask for are based on your business profile</p>
            <p>
              (Only pdf, png, jpeg and jpg formats are allowed with a max file
              size of 5MB)
            </p>
          </div>

          <Requirement categoryChoice={categoryChoice} />
        </div>

        {isFetchingRequiredDocs ? (
          <div className="center-spinner2">
            <br />
            <Spinner
              size={120}
              color={"#047558"}
              spinnerwidth={5}
              visible={true}
            />
          </div>
        ) : (
          <div>
            <div>
              <div className="upload-files">
                {categoryDocs &&
                  categoryDocs.map(
                    (category) =>
                      category.type === "url" && (
                        <UploadWidget
                          id={category.id}
                          key={category.name}
                          title={category.title}
                          handleDataFetch={handleDataFetch}
                          name={category.name}
                          handleRemoval={handleRemoval}
                        />
                      )
                  )}
              </div>

              <div className="upload-file-input">
                {categoryDocs &&
                  categoryDocs.map(
                    (category) =>
                      category.type === "input" && (
                        <InputField
                          id={category.id}
                          key={category.id}
                          name={category.name}
                          handleDataFetch={handleDataFetch}
                          title={category.title}
                        />
                      )
                  )}
              </div>
            </div>

            <div className="upload-button">
              <button
                onClick={() => submitDocs()}
                disabled={state.allResult.length === 0 || isUploading}
              >
                {isUploading ? <Loader /> : "PROCEED"}
              </button>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isUploading: state.singleUser.isUploading,
    uploadSuccess: state.singleUser.uploadSuccess,
    docs: state.docs.docs,
    appStatus: state.docs.status,
    isFetching: state.docs.isFetching,
    isFetchingRequiredDocs: state.docs.isGettingDocs,
    requiredDocs: state.docs.requiredDocs,
    getRequiredDocsSuccess: state.docs.getRequiredDocsSuccess,
  };
};

const mapDispatchToProps = (dispatch) => ({
  uploadDoc: (payload) => dispatch(uploadDoc(payload)),
  getStatus: () => dispatch(getUserStatus()),
  uploadReset: () => dispatch(uploadReset()),
  getRequiredDocs: (type) => dispatch(getRequiredDocs(type)),


});

DocumentUpload.propTypes = {
  appStatus: PropTypes.array,
  docs: PropTypes.array,
  getRequiredDocs: PropTypes.func,
  getRequiredDocsSuccess: PropTypes.bool,
  getStatus: PropTypes.func,
  isFetching: PropTypes.bool,
  isFetchingRequiredDocs: PropTypes.bool,
  isUploading: PropTypes.bool,
  requiredDocs: PropTypes.object,
  uploadDoc: PropTypes.func,
  uploadReset: PropTypes.func,
  uploadSuccess: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentUpload);